import { renderCustomBlocks, renderDataElementsBlocks, renderServiceBlocks } from "../../renderCreatedBlocks";
import viewAnnotations from './ViewAnnotations';
import exportCode from "./ExportCode";
import htmlEdit  from "./HtmlEdit";
import handleInsertCodePanel from "./HandleInsertCodePanel";
import applySameStyling from "./ApplySameStyling";
import { getAllComponents } from "../../Events/CreateRulesPerPage";

const LoadCommands = (
  editor,
  setLoadSpinnerCreateJavascript,
  setAnchorApplyStylingEl
  ) => {

    editor.Commands.add('show-tabs-panel',{
      getRowEl() {
        return editor.getContainer().closest(".editor1-row");
      },
      getStyleEl() {
        return document.querySelector(".tabPanel");
      },
      run(){
        const smEl = this.getStyleEl(this.getRowEl());
        if(smEl !== null){
          smEl.style.display = "";
        }
      },
      stop() {
        const smEl = this.getStyleEl(this.getRowEl());
        if( smEl !== null){
          smEl.style.display = "none";
        }
      }
    })
    

    editor.Commands.add("show-styles", {
      getRowEl() {
        return editor.getContainer().closest(".editor1-row");
      },
      getStyleEl() {
        return document.querySelector(".styles-container");
      },
      run() {
        const smEl = this.getStyleEl(this.getRowEl());
          smEl.style.display = "";
      },
      stop() {
        const smEl = this.getStyleEl(this.getRowEl());
        smEl.style.display = "none";
      }
    });

    editor.Commands.add("show-blocks", {
      getRowEl() {
        return editor.getContainer().closest(".editor1-row");
      },
      getStyleEl() {
        return document.querySelector(".blocks-container");
      },
      run() {
        const selectedProject = localStorage.getItem("selectedProject");
        renderServiceBlocks(editor, selectedProject);
        renderDataElementsBlocks(editor, selectedProject);
        renderCustomBlocks(editor,selectedProject);

        const smEl = this.getStyleEl(this.getRowEl());
          smEl.style.display = "";
      },
      stop() {
        const smEl = this.getStyleEl(this.getRowEl());
          smEl.style.display = "none";
      }
    });

  editor.Commands.add("show-data", {
    getRowEl() {
      return editor.getContainer().closest(".editor1-row");
    },
    getStyleEl() {
      return document.querySelector(".data-container");
    },
    run() {
      const smEl = this.getStyleEl(this.getRowEl());
        smEl.style.display = "";
    },
    stop() {
      const smEl = this.getStyleEl(this.getRowEl());
        smEl.style.display = "none";
    }
  });

  editor.Commands.add('show-layers',{
    getRowEl() {
      return editor.getContainer().closest(".editor1-row");
    },
    getStyleEl() {
      return document.querySelector(".layer-container");
    },
    run() {
      const smEl = this.getStyleEl(this.getRowEl());
        smEl.style.display = "";
    },
    stop() {
      const smEl = this.getStyleEl(this.getRowEl());
        smEl.style.display = "none";
    }
  })

  editor.Commands.add("set-device-desktop", {
    
    run() {
      try{
        const commands = editor.Commands;
        if(commands.isActive('view-annotations') === false){
          editor.setDevice("Desktop");
        }
      }
      catch(error){
        //  Await grapesJs to solve bug "Cannot read property 'frameElement' of null"
      }
    }

  });

  editor.Commands.add("set-device-tablet", {
    run() {
      try{
        const commands = editor.Commands;
        if(commands.isActive('view-annotations') === false){
          editor.setDevice("Tablet");
        }
      }
      catch(error){
        //  Await grapesJs to solve bug "Cannot read property 'frameElement' of null"
      }
    }
  });

  editor.Commands.add("set-device-mobile", {
    run() {
      try{
        const commands = editor.Commands;
        if(commands.isActive('view-annotations') === false){
          editor.setDevice("Mobile portrait");
        }
      }
      catch(error){
        //  Await grapesJs to solve bug "Cannot read property 'frameElement' of null"
      }
    }
  });

  editor.Commands.add("command-preview", {
    run() {
        const commands = editor.Commands;
        if(commands.isActive('view-annotations') === false){
          if (editor.Commands.isActive("core:preview") === false) {
              commands.run("core:preview");
          } else {
              commands.stop("core:preview");
          }
        }
      }
      
  });

  editor.Commands.add("command-export", {
    run() {
      const commands = editor.Commands;
      if(commands.isActive('view-annotations') === false){
        setLoadSpinnerCreateJavascript(true)
        commands.run("export2");
      }

    }
  });

  editor.Commands.add("command-clear-canvas", {
    run() {
      const commands = editor.Commands;     
      if(commands.isActive('view-annotations') === false){

        commands.run("core:canvas-clear");

        const selectedPage = JSON.parse(localStorage.getItem('selectedPage'));
        const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
        const tempData = JSON.parse(localStorage.getItem('data')); 
        tempData[selectedProject].pages[selectedPage].javascript = {functions: [],file: '', imports: [], changeJavascript: true, customFunctions: []};
        localStorage.setItem('data', JSON.stringify(tempData));

      }
    }

  });

  editor.Commands.add("command-export-json", {
    run() {
      const commands = editor.Commands;     
      if(commands.isActive('view-annotations') === false){
        editor.Modal.setTitle("Components JSON")
          .setContent(
            `<textarea style="width:100%; height: 250px;">
                ${JSON.stringify(editor.getComponents())}
              </textarea>`
          )
          .open();
      }
    }
  });

  editor.Commands.add("command-undo", {
    run() {
      const commands = editor.Commands;
      if(commands.isActive('view-annotations') === false){
        commands.run("core:undo");
      }
    }
  });

  editor.Commands.add("command-redo", {
    run() {
      const commands = editor.Commands;
      if(commands.isActive('view-annotations') === false){
        commands.run("core:redo");
      }
    }
  });

  editor.Commands.add('command-enable-drag-drop',{
    run(){
      const commands = editor.Commands;
      if(commands.isActive('view-annotations') === false){

        editor.setDragMode('translate');
        const all = getAllComponents(editor.DomComponents.getWrapper());

        all.forEach(comp => {
          comp.set('resizable', true);
        })

      }
    },
    stop(){
      const commands = editor.Commands;
      if(commands.isActive('view-annotations') === false){
        editor.setDragMode('none');
        const all = getAllComponents(editor.DomComponents.getWrapper());

        all.forEach(comp => {
          comp.set('resizable', false);
        })
      }
    }
  })

  editor.Commands.add("command-fullscreen", {
    run(){
    },
    stop(){
    }
  });

  editor.Commands.add("enable-navigate-page",{
    run(){

    },
    stop(){
      
    }
  })

  editor.Commands.add("enable-delete-page",{
    run(){

    },
    stop(){
      
    }
  })

  editor.Commands.add("enable-clear-page",{
    run(){

    },
    stop(){

    }
  })


editor.Commands.add('open-href-pop-up', (editorGrapes, sender,options = {}) =>  {

      const modal = editor.Modal;

      modal.open({
        title: 'External url',
        content: `
            <div style="color: #0c4d82">You will be redirected to: ${options.href}</div>      
          `,

      });
  }
  
)

viewAnnotations(editor);
exportCode(editor,setLoadSpinnerCreateJavascript);
htmlEdit(editor);
handleInsertCodePanel(editor);
applySameStyling(editor,setAnchorApplyStylingEl);

};


export default LoadCommands;
